import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const RegionRow=({region, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{region.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{region.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/region/"+region.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(region.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={region.idEstatus==1?'x':'check'} link  size="large" 
                                                color={region.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(region.id)} 
                                            />
                                        }
                                        content={region.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default RegionRow;